import { twMerge } from "tailwind-merge";
import type { IconProps } from "./types";

export const Globe3 = ({ size, color, className, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={twMerge(color == null && "h-5 w-5 stroke-current", className)}
    stroke={color}
    fill="none"
    {...props}
  >
    <path
      d="M12 2.19922C15 4.19922 15.9228 8.49125 16 12.1992C15.9228 15.9072 15 20.1992 12 22.1992M12 2.19922C9 4.19922 8.07725 8.49125 8 12.1992C8.07725 15.9072 9 20.1992 12 22.1992M12 2.19922C6.47715 2.19922 2 6.67637 2 12.1992M12 2.19922C17.5228 2.19922 22 6.67637 22 12.1992M12 22.1992C17.5229 22.1992 22 17.7221 22 12.1992M12 22.1992C6.47716 22.1992 2 17.7221 2 12.1992M22 12.1992C20 15.1992 15.708 16.122 12 16.1992C8.29203 16.122 4 15.1992 2 12.1992M22 12.1992C20 9.19922 15.708 8.27647 12 8.19922C8.29203 8.27647 4 9.19922 2 12.1992"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
